import KbArticleSidebar from './kb-article-sidebar';

export default KbArticleSidebar;
